export type PylonFn = {
  (action: 'show'): void;
  (action: 'hide'): void;
  (
    action: 'onChangeUnreadMessagesCount',
    cb: (unreadCount: number) => void
  ): void;
};

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    Pylon?: PylonFn;
    pylon?: {
      chat_settings: {
        app_id: string;
        email: string;
        name: string;
        email_hash: string;
      };
    };
  }
}

export const GETTING_STARTED_VISIBLE_CLASS = 'getting-started-visible';

export const toggleChatBubbleVisibility = (visible: boolean): void => {
  window.document.body.classList.toggle('chat-bubble-hidden', !visible);
};

/** Raises Pylon above the Getting started pill when both sit bottom-right. */
export const toggleGettingStartedPylonOffset = (active: boolean): void => {
  window.document.body.classList.toggle(GETTING_STARTED_VISIBLE_CLASS, active);
};

const markUnreadMessages = (status: boolean): void => {
  window.document.body.classList.toggle('support-messages-unread', status);
};

export const loadWidget = ({
  name,
  email,
  emailHash,
  appId,
}: {
  name: string;
  email: string;
  emailHash: string;
  appId: string;
}): void => {
  window.pylon = {
    chat_settings: {
      app_id: appId,
      email,
      name,
      email_hash: emailHash,
    },
  };
  window.Pylon?.('onChangeUnreadMessagesCount', (unreadCount) => {
    markUnreadMessages(unreadCount > 0);
    if (unreadCount > 0) {
      toggleChatBubbleVisibility(true);
    }
  });
  toggleChatBubbleVisibility(false);
};

export const openChat = (): void => {
  toggleChatBubbleVisibility(true);
  window.Pylon?.('show');
};

export const isChatLoaded = (): boolean => {
  return !!window.Pylon;
};
